// Fills in the real balance on the always-visible header widget (see
// sections/header.liquid). The widget already renders "Balance: <shop
// currency> 0.00" server-side via Liquid (correct default for guests, and a
// reserved-width placeholder for logged-in customers until this fetch
// resolves). This only overwrites that text for logged-in customers.
(() => {
  if (window.__wrpgHeaderCreditsLoaded) return;
  window.__wrpgHeaderCreditsLoaded = true;

  const widget = document.getElementById("wrpg-header-balance");
  if (!widget) return;

  const amountEl = widget.querySelector(".wrpg-header-balance__amount");
  if (!amountEl) return;

  const endpoint = widget.dataset.endpoint || "/apps/wrpg/account";

  function formatMoney(cents, currencyIso) {
    if (window.Shopify && typeof window.Shopify.formatMoney === "function" && window.Shopify.money_format) {
      return window.Shopify.formatMoney(cents, window.Shopify.money_format);
    }
    const amount = (Number(cents) / 100).toFixed(2);
    const format = String((window.Shopify && window.Shopify.money_format) || "");
    if (/£/.test(format) || currencyIso === "GBP") return `£${amount}`;
    return currencyIso ? `${amount} ${currencyIso}` : amount;
  }

  function applyBalance(data) {
    if (!data || !data.loggedIn) return;
    document.documentElement.setAttribute("data-wrpg-logged-in", "1");
    if (data.isActiveMember) document.documentElement.setAttribute("data-wrpg-member", "1");
    else document.documentElement.removeAttribute("data-wrpg-member");
    const available = Array.isArray(data.available) ? data.available : [];
    const [first] = available;
    amountEl.textContent = `Balance: ${formatMoney(first ? first.amountCents : 0, first ? first.currency : undefined)}`;
  }

  function loadBalance() {
    return fetch(`${endpoint}${endpoint.includes("?") ? "&" : "?"}t=${Date.now()}`, { cache: "no-store" })
      .then((response) => (response.ok ? response.json() : Promise.reject(new Error("account request failed"))))
      .then(applyBalance)
      .catch(() => {
        // Network hiccup - keep whatever was already rendered rather than
        // showing an error in a header widget that's visible on every page.
      });
  }

  function fromCheckout() {
    const referrer = document.referrer || "";
    return /checkout|thank[_-]?you|orders?\//i.test(referrer) || /checkout|thank[_-]?you/i.test(window.location.pathname);
  }

  loadBalance();
  if (fromCheckout()) {
    window.setTimeout(loadBalance, 2000);
    window.setTimeout(loadBalance, 5000);
  }

  window.addEventListener("pageshow", (event) => {
    if (event.persisted) loadBalance();
  });

  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "visible") loadBalance();
  });
})();
